var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"text-success font-semibold",attrs:{"to":("/a/users/" + (this.params.data.user_id) + "/progress/" + (this.params.data.course_id))}},[_vm._v("Progress")])}
var staticRenderFns = []

export { render, staticRenderFns }